/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromPayments from 'Data/payments.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Payor({
  children,
  viewPath = "/DesignSystem/LedgerPaidBy/Payor"
  
}) {
let paymentAccountValueData = fromData.useDataFormat({ viewPath,
context: 'payment',
path: 'account',
format: fromPayments.getPayorName,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment.account"
 format="/Data/payments.js getPayorName"
 text={paymentAccountValueData}
 color={dtColorsNeutral600}
/>
{children}
</React.Fragment>)
}